<template>
	<div>
		<headful
			:title="'Caseen Case -- ' + caseData.title"
		/>
		<div class="case-viewer">
			<div id="case-header">
				<h2>{{caseData.title}}</h2>
				<p>
					<i>{{caseData.description}}</i>
				</p>
			</div>
			<hr>
			<div style="background-color: #ccc; padding: 6px 8px; width: auto; display: inline-block; margin-bottom: 16px; border-radius: 4px; font-weight: bold;" 
			v-show="!this.reviewMode && active != 's0' && active != 's'+(Object.keys(slideDeck).length-1)">
				Time on case: {{this.timeElapsed}}<span v-if="caseData.time_limit > 0"> / {{caseData.time_limit}} min</span>
				<md-tooltip md-direction="bottom"><i>Note: time on case does not stop if you leave the case.</i></md-tooltip>
			</div>
			<md-steppers 
			:md-vertical="useVerticalLayout" 
			md-dynamic-height 
			md-alternative md-linear 
			:md-active-step.sync="active">
				<md-step
					v-for="slide in slideDeck" 
					:key="slide.id" 
					:id="'s'+slide.slide.order" 
					:mdDone="slide.complete"
					:md-label="slide.type"
					:md-description="slide.timepoint"
					:md-editable="reviewMode || slide.slide.order != 0"
					style="padding: 0px;"
				>
					<div :style="{'background-color': useVerticalLayout ? 'inherit' : slideBgColor(slide.type)}" :class="{'slide-viewer-container': true, 'vertical': useVerticalLayout}">
						<div class="slide-title">
							<h2>{{slide.type}}</h2>
							<span v-if="slide.timepoint" style="font-size: 115%;">
								Timepoint: {{slide.timepoint}}
							</span>
							<hr>
						</div>
						<StartSlide 
							:slide="slide" :responseData="responseData"  :myReviews="myReviews"
							:reviewMode="reviewMode" :caseID="caseID" :attemptNum="calculateAttemptNum()"
							v-if="['Begin Case'].includes(slide.type)"
							v-on:setDone="beginCase" v-on:resumeCase="resumeCase"
							:complete="slide.complete" :sanitize="sanitize"/>
						<CaseInfoSlide :slide="slide" v-if="['History', 'Physical Exam', 'Education'].includes(slide.type)" v-on:setDone="setDone" :complete="slide.complete" :sanitize="sanitize"/>
						<LabsSlide :slide="slide" :attemptRecord="attemptData[slide.id]" v-if="['Labs'].includes(slide.type)" v-on:setDone="setDone" v-on:notify="notify" :complete="slide.complete" :useVerticalLayout="useVerticalLayout" :sanitize="sanitize"/>
						<SAQuestionSlide :slide="slide" :attemptRecord="attemptData[slide.id]" v-if="['Short Answer'].includes(slide.type)" v-on:setDone="setDone" v-on:notify="notify" :complete="slide.complete" :sanitize="sanitize"/>
						<MCQuestionSlide :slide="slide" :attemptRecord="attemptData[slide.id]" v-if="['Multiple Choice'].includes(slide.type)" v-on:setDone="setDone" v-on:notify="notify" :complete="slide.complete" :sanitize="sanitize"/>
						<CKQuestionSlide :slide="slide" :attemptRecord="attemptData[slide.id]" v-if="['Checklist'].includes(slide.type)" v-on:setDone="setDone" v-on:notify="notify" :complete="slide.complete" :sanitize="sanitize"/>
						<DiagnosisSlide :slide="slide" :attemptRecord="attemptData[slide.id]" v-if="['Diagnosis'].includes(slide.type)" v-on:setDone="setDone" v-on:notify="notify" :complete="slide.complete" :sanitize="sanitize"/>
						<ReviewSlide 
							:caseID="caseID" :slideDeck="slideDeck" :performanceLog="performanceLog" 
							v-if="['Review'].includes(slide.type)" v-on:notify="notify"
							v-on:toggleNavBlock="$emit('toggleNavBlock')" :reviewMode="reviewMode"
						/>
					</div>
				</md-step>
			</md-steppers>
		</div>
		<div style="position: fixed; bottom: 30px; right: 30px; z-index: 10" v-show="active != 's0' && active != 's'+(Object.keys(slideDeck).length-1)">
			<div 
			:class="{'clipboard md-elevation-14': true, 'vertical': useVerticalLayout}"
			v-show="showClipboard">
				<div v-if="clipboard.length < 1">
					<br>
					<i>Clip notes here by highlighting important info in the case or clicking the button below.</i>
					<br>
				</div>
				<div v-else>
					<draggable 
					:options="{handle :'.drag-handle'}">
						<div
						v-for="(clipping, clippingIndex) in clipboard" 
						:key="clippingIndex"
						style="margin-bottom: 10px">
							<hr>
							<md-icon class="drag-handle" style="float: left;" v-if="!reviewMode">
								drag_handler
							</md-icon>
							<editable
									:content="clipping"
									:readonly="reviewMode"
									@update="updateClipboard(clippingIndex, $event)" 
									class="div-textarea"
							>
							</editable>
						</div>
					</draggable>
				</div>
				<hr>
				<md-button class="md-fab md-dense md-primary" @click="clipboard.push(' ')" style="transform: scale(.75); margin-top: -10px;"> 
					<md-icon>add</md-icon>
				</md-button>
			</div>
			<md-badge :md-content="clipboard.length"  md-position="bottom" md-dense>
				<md-button class="md-fab md-primary" @click="showClipboard=!showClipboard" style="transform: scale(.75);">
					<md-icon class="md-morph-initial">description</md-icon>
				</md-button>
			</md-badge>
		</div>
		<!-- Notification Snackbar -->
		<md-snackbar md-position="left" :md-duration="1500" :md-active.sync="showNotification">
				<span>{{notificationContents}}</span>
				<md-button class="md-primary" @click="showNotification=false">X</md-button>
		</md-snackbar>

	</div>
</template>

<script>
	let NoteShare = {
		// eslint-disable-next-line
		render: function (text, rawText, refUrl) {
			const shareText = DOMPurify.sanitize(this.getText(text));
			return "<a onclick='let ev = new CustomEvent(\"highlight\",  {bubbles: true, detail: \""+ shareText + "\"}); this.dispatchEvent(ev);' title=\"Write a note about it\" href=\"#\">" +
				"<svg viewBox=\"-1 -1 9 9\">" +
				"<path fill=\"currentColor\" d=\"M0 1A1 1 0 0 1 1 0H6A1 1 0 0 1 7 1V4A1 1 0 0 1 6.707 4.707L4.41 7V5H1A1 1 0 0 1 0 4 " +
				"M3 2.5A.5.5 0 0 0 4 2.5M5 2.5A.5.5 0 0 0 6 2.5.5.5 0 0 0 5 2.5M4 2.5A.5.5 0 0 03 2.5M2 2.5A.5.5 0 0 0 1 2.5.5.5 0 0 0 2 2.5\"></path>" +
				"</svg></a>";
		},
		getText(text) {
			return text.replace(/\\/, "").replace(/"/g, "\\\"").replace(/'/g, "\\\"").trim();
		},
		name: "reddit",
	}
	let scrollFunction = function(){
		let popoverElem = document.querySelector(".share-this-popover")
		if(popoverElem){
			popoverElem.style.display = "none";
		}
	}

	import StartSlide from './slides/StartSlide.vue'
	import CaseInfoSlide from './slides/CaseInfoSlide.vue'
	import LabsSlide from './slides/LabsSlide.vue'
	import SAQuestionSlide from './slides/SAQuestionSlide.vue'
	import MCQuestionSlide from './slides/MCQuestionSlide.vue'
	import CKQuestionSlide from './slides/CKQuestionSlide.vue'
	import DiagnosisSlide from './slides/DiagnosisSlide.vue'
	import ReviewSlide from './slides/ReviewSlide.vue'
	import APIRequests from './APIRequests.js'
	import Editable from './Editable.vue'

	import draggable from 'vuedraggable'

	const DOMPurify = require("dompurify")()

	import shareThis from "share-this";

	export default {
		props: {
			caseID: {
				type: String
			},
			useVerticalLayout: {
				type: Boolean
			},
			attemptString: {
				type: String,
			}
		},
		components: {
			draggable,
			Editable,
			StartSlide,
			CaseInfoSlide,
			LabsSlide,
			SAQuestionSlide,
			MCQuestionSlide,
			CKQuestionSlide,
			DiagnosisSlide,
			ReviewSlide
		},
		data: function () {
			return {
				attemptNum: undefined,
				active: 's0',
				reviewMode: false,
				caseData: {},
				attemptData: {},
				performanceLog: [],
				myReviews: {},
				responseData: [],
				slideDeck: {},
				clipboard: [],
				showClipboard: false,
				showNotification: false,
				notificationContents: "",
				timeElapsedInterval: undefined,
				timeElapsed: undefined,
			}
		},
		methods: {
			highlightFunction: function(event) {
				this.clipboard.push(event.detail)
				//Clipboard pops open on first highlight
				if(this.clipboard.length == 1){
					this.showClipboard = true
				}
				document.querySelector(".share-this-popover").style.display = "none";
			},
			sanitize: function(content){
				return "<div class=\"ql-editor\" style=\"display: inline-block; margin: auto\">" + DOMPurify.sanitize(content) + "</div>"
			},
			fetchClipboardData: function(callback){
				let api_url = this.$store.state.api_url + "/api/cases/" + this.caseID + "/attemptClipboard/" + this.attemptNum
				APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					this.clipboard = data
				}).catch(([xhrStatus, xhrResp]) => {
					alert("Could not fetch your clipboard for this case attempt: " + xhrStatus + " - " + xhrResp)
				}).then(() => {
					if(callback) callback()
				})
			},
			fetchMyReviews: function(){
				var api_url = this.$store.state.api_url + "/api/cases/" + this.caseID + "/myReviews"
				return APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					if(!data) data = []
					this.myReviews = data.reduce((aggregator, reviewEntry) => {
						aggregator[reviewEntry.attempt] = reviewEntry
						return aggregator
					}, {})
				}).catch(() => {
					setTimeout(() => {
						this.notify("Error fetching case review for your account.")
					}, 1500)
				})
			},
			fetchResponseData: function(callback) {
				var api_url = this.$store.state.api_url + "/api/cases/" + this.caseID + "/myResponses"
				APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					this.responseData = data;
					if(!this.responseData) this.responseData = []
				}).catch(([xhrStatus, xhrResp]) => {
					alert("Could not fetch your responses to this case: " + xhrStatus + " - " + xhrResp)
				}).then(() => {
					if(callback) callback()
				})
			},
			fetchCase: function (callback) {
				var api_url = this.$store.state.api_url + "/api/cases/" + this.caseID
				return APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					this.caseData = data;
					if(callback) callback()
				})
			},
			fetchAttemptData: function(cb, resume=true){
				var api_url = this.$store.state.api_url + "/api/cases/" + this.caseID + "/attempt/" + this.attemptNum
				APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					if(!data){
						window.location = "/cases/" + this.caseID
						return
					}
					var attemptArray = data.filter((x) => resume || Object.keys(x.performance).length != 0);
					this.attemptData = {}
					attemptArray.forEach((attemptEntry) => {
						if(this.attemptData[attemptEntry.sid] != undefined && Object.keys(this.attemptData[attemptEntry.sid].performance).length > 0) return
						this.$set(this.attemptData, attemptEntry.sid, attemptEntry)
					})
					cb()
				})
			},
			createReviewDeck: function(resume=false){
				let slideDeck = this.createSlideDeck(resume, false)
				if(!resume){
					var attemptSlideIDs = Object.values(this.attemptData).map(x => x.sid)
					let newDeck = {}
					Object.values(slideDeck).forEach((slide) => {
						if (attemptSlideIDs.indexOf(slide.id) != -1) {
							slide.complete = true
							var order = Object.keys(newDeck).length
							slide.slide.order = order
							newDeck[order] = slide
						}
					})
					slideDeck = newDeck
				}
				// Register slide completion
				Object.values(slideDeck).forEach((slideEntry) => {
					let attemptEntry = this.attemptData[slideEntry.id]
					if(attemptEntry){
						slideEntry.complete = true
					}
				})
				this.performanceLog = Object.values(this.attemptData);
				//Add review slide
				slideDeck[Object.keys(slideDeck).length] = {
					type: "Review",
					slide: {
						order: Object.keys(slideDeck).length
					}
				}
				this.slideDeck = slideDeck				
			},
			createSlideDeck: function(addStartSlide=true, addReviewSlide=true){
				let slideDeck = {}
				var collectSlides = function(activityObj, activityName){
					for (var i in activityObj) {
						var entry = activityObj[i]
						entry.type = activityName
						//entry.complete = false
						if(!addStartSlide) entry.slide.order = entry.slide.order - 1
						slideDeck[entry.slide.order] = entry
					}
				}
				if(addStartSlide){
					collectSlides([
						{slide: {
							order: 0
						}} 
					] , "Begin Case");
				}
				collectSlides(this.caseData.history, "History")
				collectSlides(this.caseData.physical_exams, "Physical Exam")
				collectSlides(this.caseData.labs, "Labs")
				collectSlides(this.caseData.sa_questions, "Short Answer")
				collectSlides(this.caseData.mc_questions, "Multiple Choice")
				collectSlides(this.caseData.ck_questions, "Checklist")
				collectSlides(this.caseData.ddx_questions, "Diagnosis")
				collectSlides(this.caseData.education, "Education")
				if(addReviewSlide){
					collectSlides([
						{slide: {
							order: Object.keys(slideDeck).length
						}} 
					] , "Review");
				}
				this.slideDeck = slideDeck
				return slideDeck
			},
			notify: function(notificationString){
				this.notificationContents = notificationString;
				this.showNotification = true;
			},
			scrollTop: function(focusContent){
				var scrollDist;
				if(!this.useVerticalLayout){
					scrollDist = document.getElementById("case-header").offsetTop
					if(focusContent){
						scrollDist += document.querySelector(".md-steppers-navigation").offsetHeight + 40
					}
				}
				else { 
					let qs = document.querySelector(".md-button.md-stepper-header.md-active")
					scrollDist = qs ? qs.parentNode.offsetTop + document.querySelector(".md-steppers").offsetTop : 0
				}
				var scrollTarget = document.querySelector(".md-app-scroller")
				scrollTarget.scrollTop = scrollDist
			},
			calculateAttemptNum: function(){
				if(!isNaN(this.attemptNum)){
					return this.attemptNum
				}
				var attemptNum = 0;
				this.responseData.forEach((responseElem) => {
					if(responseElem.attempt && responseElem.attempt > attemptNum){
						attemptNum = responseElem.attempt
					}
				})
				return attemptNum + 1
			},
			updateClipboard: function(clipIndex, newText){
				if(newText.trim() == ""){
					this.clipboard.splice(clipIndex, 1)
				}
				else {
					this.$set(this.clipboard, clipIndex, newText)
				}
			},
			sendClipboardContents: function(){
				if(!this.reviewMode){
					let requestData = {
						cid: this.caseID,
						attempt: this.calculateAttemptNum(),
						clipboard: this.clipboard,
					}
					APIRequests.postJSONData(
						this.$store.state.api_url + "/api/cases/" + this.caseID + "/updateClipboard", 
						requestData,
						this.$store.state.jwtToken
					).catch(() => {
						this.notify("Error saving case clipboard, please try refreshing the page and try again.")
					})
				}
			},
			windowCloseWarning: function(){
				const max_slides = Object.keys(this.slideDeck).length
				if ("s"+(max_slides-1) == this.active) {
					return
				}
				return confirm("Progress will be lost, are you sure you want to leave?")
			},
			beginCase: function(setDoneParams){
				if(!this.reviewMode){
					this.$emit("toggleNavBlock")
				}
				this.setDone(setDoneParams)
				this.startTimer(Math.floor(Date.now()/1000))
			},
			startTimer: function(startTime) {
				this.timeElapsedInterval = setInterval(() => {
					const now = Math.floor(Date.now()/1000);
					const secElapsed = now - startTime;
					// Format time elapsed
					if (secElapsed < 60) {
						this.timeElapsed =  `${secElapsed} sec`
					}
					else if (secElapsed / 60 / 60 > 1) {
						this.timeElapsed = `${(secElapsed / 60 / 60).toFixed(1)} hours`;
					} 
					else {
						this.timeElapsed = `${(secElapsed / 60).toFixed(1)} min`;
					}
				}, 500)
			},
			setDone: function ([orderNum, advanceSlide, performance]) {
				//Only save changes if not in review mode
				if(!this.reviewMode){
					window.onbeforeunload = this.windowCloseWarning;
					this.$set(this.slideDeck[orderNum], "complete", true);
					//Register slide completion with server
					var performanceEntry = Object.assign({}, performance)
					performanceEntry.attempt = this.calculateAttemptNum()
					performanceEntry.order = orderNum
					performanceEntry.slideType = this.slideDeck[orderNum].type
					performanceEntry.finishTime = Math.floor(Date.now()/1000)
					performanceEntry.sid = this.slideDeck[orderNum].id
					performanceEntry.last_slide = orderNum == (Object.keys(this.slideDeck).length - 2)
					// Stop updating timer at end of case
					if (performanceEntry.last_slide) {
						clearInterval(this.timeElapsedInterval)
					}
					performanceEntry.reporting = {}
					if(this.$route.query.classroom){
						performanceEntry.reporting.classroomID = this.$route.query.classroom
					}
					if(this.$route.query.assignment){
						performanceEntry.reporting.assignmentID = this.$route.query.assignment
					}
					if(!performanceEntry.sid) performanceEntry.sid = this.caseID
					this.performanceLog.push(performanceEntry)
					APIRequests.postJSONData(
						this.$store.state.api_url + "/api/cases/" + this.caseID + "/" + performanceEntry.sid + "/completeSlide", 
						performanceEntry,
						this.$store.state.jwtToken
					).then(() => {
						this.notify("Case progress saved!")
					}).catch(() => {
						this.notify("Error saving case progress, please try refreshing the page and try again.")
					})
					//Send clipboard to db
					this.sendClipboardContents();
				}
				//Advance to the next slide
				if(advanceSlide){
					//Advance to next slide if it exists
					var max_slides = Object.keys(this.slideDeck).length
					if (orderNum < max_slides) {
						this.active = 's'+(orderNum+1)
					}
				}
				//Scroll back to top so learner can either review or start reading next slide
				this.scrollTop(false)
			},
			resumeCase: function(attemptNum){
				this.attemptNum = attemptNum
				this.fetchClipboardData(() => {
					this.fetchAttemptData(() => {
						this.createReviewDeck(true)
						this.setDone([0, true, undefined])
						// Start timer
						let startTime = this.attemptData[this.caseID].finishTime; 
						this.startTimer(startTime ? startTime : Date.now())
					}, true)
				})
			},
			slideBgColor: function(slideType) {
				const bgMap = {
					"Begin Case": "#e9f1f0",
					"History": "#f1edf2",
					"Physical Exam": "#f1edf2",
					"Labs": "#f3fcfc",
					"Education": "#fefff7",
				}
				return bgMap[slideType] || 	"#f6f6f6";
			}
		},
		mounted: function () {
			this.$nextTick(function () {
				this.scrollTop(false)
				this.fetchCase(() => {
					this.attemptNum = parseInt(this.attemptString)
					if(!isNaN(this.attemptNum)){
						this.reviewMode = true
						this.fetchClipboardData(() => {
							this.fetchAttemptData(() => {
								this.createReviewDeck()
								//Start review activity on review slide rather than 1st slide
								this.active = `s${Object.keys(this.slideDeck).length - 1}`
							})
						})
					} else {
						this.reviewMode = false
						this.fetchMyReviews()
						this.fetchResponseData(() => {
							this.createSlideDeck()  
							const selectionShare = shareThis({
									selector: '.highlightable',
									sharers: [NoteShare]
							});
							selectionShare.init();
							document.addEventListener("highlight", this.highlightFunction);
							//Hide highlight dialog on scroll
							document.addEventListener('scroll', scrollFunction, true)
						})
					}
				}).catch(() => {
					this.$router.replace("/cases")
				})
			})
		},
		beforeDestroy: function (){
			clearInterval(this.timeElapsedInterval)
			document.removeEventListener("highlight", this.highlightFunction)
			document.removeEventListener("scroll", scrollFunction)
			window.onbeforeunload = () => {}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.md-steppers-wrapper{
		height: inherit !important;
	}
	.md-steppers-navigation{
		overflow-x: scroll !important;
		padding-bottom: 12px;
	}
	.md-stepper-header{
		min-width: 200px !important;
	}
	.md-stepper-label{
		font-weight: bold;
		font-size: 110%;
	}
	.slide-title h2{
		margin-bottom: 5px;
	}
	.md-vertical .md-steppers-container{
		margin-left: -22px;
	}
	.md-stepper-editable svg{
		display: none;
	}
	.md-vertical .md-stepper-content {
		padding-left: 30px !important;
		padding-right: 10px !important;
	}
	.md-vertical .md-stepper:after {
		background-color: #ffffff00 !important;
	}
	.slide-viewer-container:not(.vertical) {
		padding: 16px 24px; 
		border-bottom-left-radius: 6px; 
		border-bottom-right-radius: 6px;
		box-shadow: inset 0px 2px 5px #666;
	}
	.slide-viewer-container.vertical {
		padding: 0px;
	}
	.clipboard{
		position: absolute; 
		bottom: 80px; 
		right: 30px; 
		width: 20vw; 
		min-width: 20vw;
		min-height: 110px;
		max-height: 70vh;
		max-width: 30vw;
		overflow-y: auto;
		background-color: #f2ead0;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		padding: 4px 8px;
		resize: both;
		font-size: 90%;
		line-height: 125%;
	}
	.clipboard.vertical{
		bottom: -30px;
		right: -30px;
		min-width: 100vw;
		width: 100vw;
		height: 92.5vh;
		max-height: 100vh; 
		resize: none;
	}
	.md-badge.md-position-bottom{
		bottom: 0;
		right: 5px;
	}
	.question-review-change-notice{
		margin: 20px;
	}
	.question-review-change-notice b{
		border: 1.5px solid red; 
		padding: 8px;
	}
</style>

<style>
	.share-this-popover {
		max-width: 8em;
		pointer-events: none;
		-webkit-filter: drop-shadow(0 1px 3px rgba(0, 0, 0, .35));
		filter: drop-shadow(0 1px 3px rgba(0, 0, 0, .35));
		-webkit-animation: a .3s;
		animation: a .3s
	}

	.share-this-popover:before {
		content: "";
		position: absolute;
		bottom: 100%;
		left: 50%;
		width: 0;
		height: 0;
		margin: .25em -.5em;
		border-width: .5em .5em 0;
		border-style: solid;
		border-color: #333 transparent
	}

	.share-this-popover>ul {
		pointer-events: auto;
		list-style: none;
		padding: 0;
		margin: -.75em 0 0;
		white-space: nowrap;
		background: #333;
		color: #fff;
		border-radius: .25em;
		position: absolute;
		left: 50%;
		-webkit-transform: translate(-50%, -100%);
		-ms-transform: translate(-50%, -100%);
		transform: translate(-50%, -100%)
	}

	.share-this-popover>ul>li {
		display: inline-block;
		width: 2em;
		height: 2em;
		line-height: 2em;
		text-align: center
	}

	.share-this-popover>ul>li>a {
		display: inline-block;
		width: 100%;
		height: 100%;
		color: inherit;
		box-sizing: border-box;
		padding: .35em
	}

	.share-this-popover>ul>li>a:focus,
	.share-this-popover>ul>li>a:hover {
		background: hsla(0, 0%, 100%, .25)
	}

	.share-this-popover>ul>li>a polyline {
		stroke: #fff
	}

	@media (pointer:coarse) {
		.share-this-popover {
			font-size: 150%
		}

		.share-this-popover:before {
			bottom: auto;
			top: 100%;
			border-width: 0 .5em .5em;
			margin-top: 0
		}

		.share-this-popover>ul {
			top: 100%;
			transform: translateX(-50%);
			margin: .5em 0 0
		}
	}

	@-webkit-keyframes a {
		0% {
			-webkit-transform: translateY(-3em);
			opacity: 0
		}

		80% {
			-webkit-transform: translateY(.5em);
			opacity: 1
		}

		to {
			-webkit-transform: translateY(0)
		}
	}

	@keyframes a {
		0% {
			transform: translateY(-3em);
			opacity: 0
		}

		80% {
			transform: translateY(.5em);
			opacity: 1
		}

		to {
			transform: translateY(0)
		}
	}
</style>